/**
 * External dependencies
 */
import { some } from 'lodash';

/**
 * Internal dependencies
 */
import getLocationGroup from './get-location-group';
import getEdits from './get-edits';

export default (state, locationGroupId) => {
     
    const locationGroup = getLocationGroup(state, locationGroupId);
    const edits = getEdits(state, locationGroupId);

    if (!edits) {
        return false;
    }
   
    if (!locationGroup && edits) {
        return true;
    }

    if (!locationGroup) {
        return false;
    }

    const editsDirty = some(edits, (value, key) => {
        return locationGroup[key] !== value;
    });

    return editsDirty;
};